import React from "react";
import styles from "./styles.module.scss";
import { PageSubHeaderProps } from "./types";

const PageSubHeader = ({ title }: PageSubHeaderProps) => (
  <h2 className={styles["page-sub-header"]}>{title}</h2>
);

export default PageSubHeader;
